
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({})
export default class OpenDoorDialog extends Vue {

    @Prop({default: false})
    public dialog: boolean;

    @Prop({default: {}})
    public nonTransferable: any;

    @Getter private isMobile: boolean;

    private confirm: boolean = false;
    private loading: boolean = false;

    private async openDoor(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("nonTransferables/openDoor", {
            id: this.nonTransferable.id,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("NonTransferable.openDoor.success"),
            });
            this.$emit("success");
            this.$emit("close");
            this.confirm = false;
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }

    private close(): void {
        this.$emit("close");
    }
}
